export interface CharacterStats {
    character: string;
    gameCount: number;
}

const defaultCharacterStat: CharacterStats = {
    character: '',
    gameCount: 0
}

interface RankedNetplayProfile {
    ratingOrdinal: number;
    ratingUpdateCount: number;
    wins: number;
    losses: number;
    dailyGlobalPlacement: number | null;
    dailyRegionalPlacement: number | null;
    characters: CharacterStats[];
}

const defaultRankedNetplayProfile: RankedNetplayProfile = {
    ratingOrdinal: 0,
    ratingUpdateCount: 0,
    wins: 0,
    losses: 0,
    dailyGlobalPlacement: null,
    dailyRegionalPlacement: null,
    characters: [defaultCharacterStat],
}

export interface Player {
    displayName: string;
    connectCode: {
        code: string;
    };
    rankedNetplayProfile: RankedNetplayProfile
    oldRankedNetplayProfile?: RankedNetplayProfile // populated separately
}

export const DefaultPlayer: Player = {
    displayName: '',
    connectCode: {
        code: ''
    },
    rankedNetplayProfile: defaultRankedNetplayProfile,
    oldRankedNetplayProfile: defaultRankedNetplayProfile
}